<template>
    <div class="menu-btn mx-md text-lg md:hidden cursor-pointer w-lg" @click="toggle">
        <font-awesome-icon v-if="! shown" icon="bars" />
        <font-awesome-icon v-else icon="times" />
    </div>
</template>
<script>
    export default {
        data() {
            return {
                shown: false,
            };
        },
        created() {
            EventBus.$on('toggle-admin-sidebar', () => {
                this.shown = ! this.shown;
            });
        },
        methods: {
            toggle() {
                EventBus.$emit('toggle-admin-sidebar');
            },
        },
    };
</script>